<template>
  <div class="account-nav" ref="accountnav">
    <b-tabs content-class="tab-content pb-2" fill class="tab-area">
      <b-tab title="Recent Accounts" :active="isRecentTabVisible == true">
        <div id="norecentaccounts" class="no-recent-accounts" v-if="recentAccountsForUser.length == 0">No Recent Accounts
          Found !!</div>
        <ul v-else class="list-style-none pl-3 pr-3 recent-parent-account-ul"
          v-bind:style="{ 'max-height': recentmaxheight }">
          <li v-for="(recentaccount) in recentAccountsForUser" :key="recentaccount.accountNumber" class="open-nav in">
            <a :class="recentaccount.accountNumber == accountNoSelected ? 'selected-account' : ''"
              href="javasript:void(0)" v-on:click="bindUserGrid(recentaccount)" :title="recentaccount.accountName">{{
                recentaccount.accountNumber }}
              - {{ recentaccount.accountName }}</a>
          </li>
        </ul>
      </b-tab>
      <b-tab title="Explore Accounts" :active="isRecentTabVisible == false">
        <div>
          <div class="form-group search-account-div">
            <div class="input-group">
              <input type="text" class="form-control" title="Search By Account Name or Account Number"
                placeholder="Search By Account Name or Account Number" id="accountSearch" v-model="accountToSearch"
                v-sanitize-html="accountToSearch" />
              <span title="Type to search account" class="input-group-addon" style="height: 34px;">
                <font-awesome-icon icon="search" />
              </span>
            </div>
          </div>
          <ul class="menu-content parent-account-ul" v-bind:style="{ 'max-height': maxheight }">
            <li v-for="(account) in accountsHirerachy" :key="account.accountNumber" class="open-nav in">
              <template>
                <a href="javasript:void(0)" v-if="(account.children != null && account.children.length > 0)"
                  v-b-toggle="'collapse-' + account.accountNumber">
                  <span
                    :class="account.accountNumber == accountNoSelected || (isparentAccountSearched && !ischildAccountSearched) ? 'when-opened account-nav-icon selected-account' : 'when-opened account-nav-icon'"
                    title="Expand/Collapse child account(s)">
                    <font-awesome-icon icon="minus" />
                  </span>
                  <span
                    :class="account.accountNumber == accountNoSelected || (isparentAccountSearched && !ischildAccountSearched) ? 'when-closed account-nav-icon selected-account' : 'when-closed account-nav-icon'"
                    title="Expand/Collapse child account(s)">
                    <font-awesome-icon icon="plus" />
                  </span>
                </a>
                <span v-else class="pl-3"></span>
                <a :id="'a-' + account.accountNumber"
                  :class="account.accountNumber == accountNoSelected || (isparentAccountSearched && !ischildAccountSearched) ? 'selected-account' : ''"
                  href="javasript:void(0)" v-on:click="bindUserGrid(account)" :title="account.accountName">{{
                    account.accountNumber }} - {{ account.accountName }}</a>
                <b-collapse :id="'collapse-' + account.accountNumber"
                  :visible="(ischildAccountSearched || account.parentExpand) ? true : false">
                  <ul class="menu-content open-nav in" :id="'ul-' + account.accountNumber"
                    v-if="(account.children != null && account.children.length > 0)">
                    <li v-for="childAccount in account.children" :key="childAccount.accountNumber" class="open-nav in">
                      <template>
                        <a href="javasript:void(0)"
                          v-if="(childAccount.children != null && childAccount.children.length > 0)"
                          v-b-toggle="childAccount.accountNumber">
                          <span
                            :class="childAccount.accountNumber == accountNoSelected || (ischildAccountSearched && !isgChildAccountSearched && !childAccount.selectflag) ? 'when-opened account-nav-icon selected-account' : 'when-opened account-nav-icon'"
                            title="Expand/Collapse child account(s)">
                            <font-awesome-icon icon="minus" />
                          </span>
                          <span
                            :class="childAccount.accountNumber == accountNoSelected || (ischildAccountSearched && !isgChildAccountSearched && !childAccount.selectflag) ? 'when-closed account-nav-icon selected-account' : 'when-closed account-nav-icon'"
                            title="Expand/Collapse child account(s)">
                            <font-awesome-icon icon="plus" />
                          </span>
                        </a>
                        <span v-else class="pl-3"></span>
                        <a :id="'a-' + childAccount.accountNumber"
                          :class="childAccount.accountNumber == accountNoSelected || (ischildAccountSearched && !isgChildAccountSearched && !childAccount.selectflag) ? 'selected-account' : ''"
                          href="javasript:void(0)" v-on:click="bindUserGrid(childAccount)"
                          :title="childAccount.accountName">{{ childAccount.accountNumber }} -
                          {{ childAccount.accountName }}</a>
                        <b-collapse :id="childAccount.accountNumber"
                          :visible="(isgChildAccountSearched || childAccount.childExpand) ? true : false">
                          <ul class="menu-content open-nav in pl-3" :id="childAccount.accountNumber"
                            v-if="(childAccount.children != null && childAccount.children.length > 0)">
                            <li v-for="grandChild in childAccount.children" :key="grandChild.accountNumber">
                              <template>
                                <span class="pl-3"></span>
                                <a :id="'a-' + grandChild.accountNumber"
                                  :class="grandChild.accountNumber == accountNoSelected || isgChildAccountSearched ? 'selected-account' : ''"
                                  href="javasript:void(0)" v-on:click="bindUserGrid(grandChild)"
                                  :title="grandChild.accountName">{{ grandChild.accountNumber }} -
                                  {{ grandChild.accountName }}</a>
                              </template>
                            </li>
                          </ul>
                        </b-collapse>
                      </template>
                    </li>
                  </ul>
                </b-collapse>
              </template>
            </li>
          </ul>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import { eventbus } from "../../main";
export default {
  name: "AccountNavigation",
  data() {
    return {
      scrollToElementID: "",
      isRecentTabVisible: true,
      accountNoSelected: this.selectedAccountNumber.accountNumber,
      recentAccounts: [],
      accountToSearch: "",
      isparentAccountSearched: false,
      ischildAccountSearched: false,
      isgChildAccountSearched: false,
      recentAccountsForUser: [],
      accountsForNavigation: [],
      maxheight: "",
      recentmaxheight: "",
      username: ""
    };
  },
  props: {
    selectedAccountNumber: {}
  },
  computed: {
    accountsHirerachy: function () {
      if (this.accountToSearch != "") {
        return this.filterByNameOrNumber();
      } else {
        this.resetcollapse();
        this.selectAccount();
        return this.accountsForNavigation;
      }
    }
  },
  created() {
    window.addEventListener("resize", this.handleHeightResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleHeightResize);
  },
  recentAccountsForUser: function (val) {
    this.recentAccountsForUser = val;
  },
  mounted() {
    //console.log('mounted',this.selectedAccountNumber);
    var that = this;
    that.username = this.$store.getters.username;
    that.accountsForNavigation = this.$store.getters.accountHierarchy;
    that.getRecentAccounts();
    that.handleHeightResize();

    eventbus.$on("UpdateHideInactiveContactFlag", function (updatedAccount) {
      that.updateHideInactiveContactFlag(updatedAccount);
    });

    if (that.isRecentTabVisible == true) {
      var accountData = {
        accountId: that.recentAccountsForUser[0].accountId,
        accountName: that.recentAccountsForUser[0].accountName,
        accountNumber: that.recentAccountsForUser[0].accountNumber,
        hideInactiveContact: that.recentAccountsForUser[0].hideInactiveContact

      };
      setTimeout(() => {
        that.accountNoSelected = accountData.accountNumber;
        eventbus.$emit("OnAccountNumberChange", accountData);
      }, 15);
    } else {
      setTimeout(() => {
        that.accountNoSelected = that.selectedAccountNumber.accountNumber;
        eventbus.$emit("OnAccountNumberChange", that.selectedAccountNumber);
      }, 15);
    }
  },
  methods: {
    handleHeightResize() {
      this.maxheight =
        window.innerHeight -
        this.$refs.accountnav.getBoundingClientRect().top -
        120 +
        "px";
      this.recentmaxheight =
        window.innerHeight -
        this.$refs.accountnav.getBoundingClientRect().top -
        70 +
        "px";
    },
    resetcollapse: function () {
      this.isparentAccountSearched = false;
      this.ischildAccountSearched = false;
      this.isgChildAccountSearched = false;
    },
    filterByNameOrNumber: function () {
      var that = this;
      var filteredAccounts = [];
      //console.log("String To Search", that.accountToSearch);
      that.accountsForNavigation.forEach(function (account) {
        if (
          account.accountNumber.includes(that.accountToSearch) ||
          account.accountName
            .toLowerCase()
            .includes(that.accountToSearch.toLowerCase())
        ) {
          that.isparentAccountSearched = true;
          if (filteredAccounts.length <= 0) filteredAccounts.push(account);
          else {
            var i = filteredAccounts.findIndex(
              x => x.accountId == account.accountId
            );
            if (i == -1) {
              filteredAccounts.push(account);
            }
          }
        } else if (account.children != null) {
          account.children.forEach(function (childAccount) {
            if (
              childAccount.accountNumber.includes(that.accountToSearch) ||
              childAccount.accountName
                .toLowerCase()
                .includes(that.accountToSearch.toLowerCase())
            ) {
              that.isparentAccountSearched = true;
              that.ischildAccountSearched = true;
              childAccount.selectflag = false;
              var _account = {
                accountId: account.accountId,
                accountName: account.accountName,
                accountNumber: account.accountNumber,
                parentAccountNumber: account.parentAccountNumber,
                hideInactiveContact: account.hideInactiveContact,
                children: [
                  {
                    accountId: childAccount.accountId,
                    accountName: childAccount.accountName,
                    accountNumber: childAccount.accountNumber,
                    parentAccountNumber: childAccount.parentAccountNumber,
                    hideInactiveContact: childAccount.hideInactiveContact,
                    children: childAccount.children
                  }
                ]
              };
              if (filteredAccounts.length == 0) filteredAccounts.push(_account);
              else {
                var i = filteredAccounts.findIndex(
                  x => x.accountId == account.accountId
                );
                if (i == -1) {
                  filteredAccounts.push(_account);
                } else {
                  var j = filteredAccounts[i].children.findIndex(
                    x => x.accountId == childAccount.accountId
                  );
                  if (j == -1) {
                    filteredAccounts[i].children.push(_account.children[0]);
                  }
                }
              }
            } else if (childAccount.children != null) {
              childAccount.children.forEach(function (granChildAccount) {
                if (
                  granChildAccount.accountNumber.includes(that.accountToSearch) ||
                  granChildAccount.accountName
                    .toLowerCase()
                    .includes(that.accountToSearch.toLowerCase() != -1)
                ) {
                  that.isparentAccountSearched = true;
                  that.ischildAccountSearched = true;
                  that.isgChildAccountSearched = true;
                  var _account = {
                    accountId: account.accountId,
                    accountName: account.accountName,
                    accountNumber: account.accountNumber,
                    parentAccountNumber: account.parentAccountNumber,
                    hideInactiveContact: account.hideInactiveContact,
                    children: [
                      {
                        accountId: childAccount.accountId,
                        accountName: childAccount.accountName,
                        accountNumber: childAccount.accountNumber,
                        parentAccountNumber: childAccount.parentAccountNumber,
                        hideInactiveContact: childAccount.hideInactiveContact,
                        children: [
                          {
                            accountId: granChildAccount.accountId,
                            accountName: granChildAccount.accountName,
                            accountNumber: granChildAccount.accountNumber,
                            parentAccountNumber:
                              granChildAccount.parentAccountNumber,
                            children: granChildAccount.children,
                            hideInactiveContact: granChildAccount.hideInactiveContact
                          }
                        ]
                      }
                    ]
                  };

                  if (filteredAccounts.length == 0)
                    filteredAccounts.push(_account);
                  else {
                    var i = filteredAccounts.findIndex(
                      x => x.accountId == account.accountId
                    );
                    if (i == -1) {
                      filteredAccounts.push(_account);
                    } else {
                      var j = filteredAccounts[i].children.findIndex(
                        x => x.accountId == childAccount.accountId
                      );
                      if (j == -1) {
                        filteredAccounts[i].children.push(_account.children[0]);
                      } else {
                        var k = filteredAccounts[i].children[
                          j
                        ].children.findIndex(
                          x => x.accountId == granChildAccount.accountId
                        );
                        if (k == -1) {
                          filteredAccounts[i].children[j].children.push(
                            granChildAccount
                          );
                        }
                      }
                    }
                  }
                }
              });
            }
          });
        }
      });
      return filteredAccounts;
    },
    selectAccount: function () {
      var that = this;
      that.accountsForNavigation.forEach(function (account) {
        // console.log("account.accountNumber", account.accountNumber);
        // console.log("that.selectedAccountNumber.accountNumber",that.selectedAccountNumber.accountNumber);
        if (account.accountNumber == that.selectedAccountNumber.accountNumber) {
          that.scrollToElementID = "#a-" + account.accountNumber;
        } else if (account.children != null) {
          account.children.forEach(function (childAccount) {
            if (
              childAccount.accountNumber ==
              that.selectedAccountNumber.accountNumber
            ) {
              //console.log("Inside Child");
              account.parentExpand = true;
              //console.log('childAccount.accountNumber',childAccount.accountNumber);
              //console.log('account.parentExpand',account.parentExpand);
              that.scrollToElementID = "#a-" + childAccount.accountNumber;
            } else if (childAccount.children != null) {
              childAccount.children.forEach(function (granChildAccount) {
                if (
                  granChildAccount.accountNumber ==
                  that.selectedAccountNumber.accountNumber
                ) {
                  childAccount.childExpand = true;
                  account.parentExpand = true;
                  that.scrollToElementID =
                    "#a-" + granChildAccount.accountNumber;
                } else {
                  //console.log('inside Else gchild');
                  childAccount.childExpand = false;
                }
              });
            } else {
              //console.log('inside Else child');
              childAccount.childExpand = false;
            }
          });
        } else {
          //console.log('inside Else Parent');
          account.parentExpand = false;
        }
      });
    },
    bindUserGrid: function (selectedAccount) {
      this.accountNoSelected = selectedAccount.accountNumber;
      this.storeRecentAccountsByAdfsGuid(selectedAccount);
      eventbus.$emit("OnAccountNumberChange", selectedAccount);
    },
    storeRecentAccountsByAdfsGuid: function (account) {
      var that = this;
      var expiryTime = 10;
      var data = localStorage.getItem(that.username);
      var dayInMilliseconds = 86400000;
      if (data) {
        var accountMatch = false;
        var accountData = JSON.parse(data);
        accountData.forEach(function (acc) {
          if (acc.accountNumber == account.accountNumber) {
            //console.log("Matched before change", acc.expireTime);
            acc.time = new Date().getTime();
            acc.expireTime =
              new Date().getTime() + dayInMilliseconds * expiryTime;
            accountMatch = true;
            //console.log("Matched after change", acc.expireTime);
          }
        });
        if (!accountMatch) {
          accountData.push({
            accountNumber: account.accountNumber,
            accountName: account.accountName,
            accountId: account.accountId,
            parentAccountNumber: account.parentAccountNumber,
            hideInactiveContact: account.hideInactiveContact,
            time: new Date().getTime(),
            expireTime: new Date().getTime() + dayInMilliseconds * expiryTime
          });
          that.recentAccountsForUser.push({
            accountNumber: account.accountNumber,
            accountName: account.accountName,
            accountId: account.accountId,
            parentAccountNumber: account.parentAccountNumber,
            hideInactiveContact: account.hideInactiveContact,
            time: new Date().getTime()
          });
        }
        localStorage.setItem(that.username, JSON.stringify(accountData));
      } else {
        var recentAccounts = [];
        recentAccounts.push({
          accountNumber: account.accountNumber,
          accountName: account.accountName,
          accountId: account.accountId,
          hideInactiveContact: account.hideInactiveContact,
          parentAccountNumber: account.parentAccountNumber,
          time: new Date().getTime(),
          expireTime: new Date().getTime() + dayInMilliseconds * expiryTime
        });
        localStorage.setItem(that.username, JSON.stringify(recentAccounts));
        that.recentAccountsForUser.push({
          accountNumber: account.accountNumber,
          accountName: account.accountName,
          accountId: account.accountId,
          parentAccountNumber: account.parentAccountNumber,
          hideInactiveContact: account.hideInactiveContact,
          time: new Date().getTime()
        });
      }
      that.recentAccountsForUser.sort(function (x, y) {
        return y.time - x.time;
      });
    },
    getRecentAccounts: function () {
      if (localStorage.getItem(this.username)) {
        this.recentAccounts = [];
        var data = localStorage.getItem(this.username);
        this.recentAccounts = JSON.parse(data);
      }
      var that = this;
      if (this.recentAccounts) {
        this.recentAccountsForUser = [];
        this.recentAccounts.forEach(function (recentAcount) {
          if (recentAcount.expireTime >= new Date().getTime()) {
            that.recentAccountsForUser.push({
              time: recentAcount.time,
              accountNumber: recentAcount.accountNumber,
              accountName: recentAcount.accountName,
              accountId: recentAcount.accountId,
              parentAccountNumber: recentAcount.parentAccountNumber,
              hideInactiveContact: recentAcount.hideInactiveContact
            });
          }
        });
        this.recentAccountsForUser.sort(function (x, y) {
          return y.time - x.time;
        });
      }
      this.isRecentTabVisible = this.recentAccountsForUser.length > 0;
    },

    updateHideInactiveContactFlag: function (updatedAccount) {
      var that = this;
      if (updatedAccount != "undefined" && updatedAccount != null) {
        //Recent Accounts
        if (that.recentAccountsForUser != null && that.recentAccountsForUser != "undefined" && that.recentAccountsForUser.length > 0) {
          var recentAccount = that.recentAccountsForUser.find(x => x.accountNumber == updatedAccount.accountNumber);
          if (recentAccount != null && recentAccount != "undefined") {
            recentAccount.hideInactiveContact = updatedAccount.hideInactiveContact;
          }
        }
        //Account Hierarchy
        if (that.accountsHirerachy != null && that.accountsHirerachy != "undefined" && that.accountsHirerachy.length > 0) {
          var account = that.accountsHirerachy.find(x => x.accountNumber == updatedAccount.accountNumber);
          if (account != null && account != "undefined")
            account.hideInactiveContact = updatedAccount.hideInactiveContact;
          else {
            that.accountsHirerachy.forEach(function (acc) {
              if (acc.children != null && acc.children != "undefined" && acc.children.length > 0) {
                var childAccount = acc.children.find(x => x.accountNumber == updatedAccount.accountNumber);
                if (childAccount != null && childAccount != "undefined")
                  childAccount.hideInactiveContact = updatedAccount.hideInactiveContact;
                else {
                  acc.children.forEach(function (childAcc) {
                    if (childAcc.children != null && childAcc.children != "undefined" && childAcc.children.length > 0) {
                      var grandChildAccount = childAcc.children.find(x => x.accountNumber == updatedAccount.accountNumber);
                      if (grandChildAccount != null && grandChildAccount != "undefined")
                        grandChildAccount.hideInactiveContact = updatedAccount.hideInactiveContact;
                    }
                  });
                }
              }
            });
          }
        }
      }
    }
  }
};
</script>